import { Pipe, PipeTransform } from '@angular/core'
import { JoinPipe } from '../array/join.pipe'
import { DisplayTitlePipe } from './displayTitle.pipe'

@Pipe({
    name: 'displayProfessionnels'
})

export class DisplayProfessionnelsPipe implements PipeTransform {
    constructor(
        private displayTitlePipe: DisplayTitlePipe,
        private joinPipe: JoinPipe
    ) { }
    professionnels: string
    transform(professionnelsArr: any, ...args: any[]) {
        if (professionnelsArr && professionnelsArr.length > 0) {
            let tmpProList: any[] = []
            this.professionnels = ''
            professionnelsArr.forEach(professionnel => {
                tmpProList.push(this.displayTitlePipe.transform(professionnel))
            })
            this.professionnels = this.joinPipe.transform(tmpProList, ', ')
        } else {
            this.professionnels = 'Aucun professionnel'
        }
        return this.professionnels
    }
}
